<img
  class="hero"
  ngSrc="hero/hero-andy.avif"
  fill
  priority
  sizes="100vw"
  alt=""
  placeholder
/>
<main>
  <img
    class="ball"
    ngSrc="img/8-big.png"
    alt="A black '8' ball"
    width="256"
    height="256"
    data-testid="app-logo"
    [priority]="true"
  />
  <h1 data-testid="app-header">Backbase Cardiff Pool League</h1>
  <p data-testid="app-welcome-message">
    Please log in with your Backbase Google account.
  </p>
  <p>
    <button type="button" data-testid="login-button" (click)="login()">
      Log in with Google
    </button>
  </p>
</main>
